import React, { useState, useEffect } from "react";

import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { RootState } from "../../redux/store";
import { fetchLeaderboard } from "../../features/auth/store/userSlice";
import { FaSpinner } from "react-icons/fa";

const Leaderboard = () => {
  const [toggle, setToggle] = useState<string>("monthly");
  const dispatch = useAppDispatch();
  const { leaderboard, loading } = useAppSelector(
    (state: RootState) => state.users,
  );

  useEffect(() => {
    dispatch(fetchLeaderboard(toggle));
  }, [toggle, dispatch]);

  return (
    <div
      className="col-4 p-4 rounded-lg min-w-[288px] dark:bg-zinc-900"
      style={{
        backgroundImage: `url(/images/bg.png)`,
        backgroundPosition: "center top",
        backgroundSize: "400% 300%",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Header toggle={toggle} setToggle={setToggle} />
      <Body data={leaderboard || []} loading={loading} type={toggle} />
    </div>
  );
};

export default Leaderboard;

const Header = ({
  toggle,
  setToggle,
}: {
  toggle: string;
  setToggle: (val: string) => void;
}) => {
  return (
    <div className="col-4">
      <div className="col-2 place-items-center">
        <img src="/crown.png" alt="" className="size-10" />
        <span className="lt-xl-semibold-main-dark text-gray-600 dark:text-white dark:bg-white/10 px-2 rounded">
          Leaderboard
        </span>
      </div>
      <div className="rounded-2xl p-[6px] row-2 bg-BG-light dark:bg-zinc-800/80 backdrop-blur-sm transition-colors">
        {["monthly", "allTime"].map((item, index) => (
          <button
            key={index}
            className={`flex-1 py-[6px] px-[10px] place-content-center rounded-full transition-all ${
              toggle === item
                ? "inter-xs-semibold-white rounded-2xl bg-toggleBG-light dark:bg-blue-600 dark:text-white"
                : "inter-xs-medium-toggleBG-dark text-gray-500 dark:text-zinc-400"
            }`}
            onClick={() => setToggle(item)}
          >
            {item === "monthly" ? "Monthly" : "All Time"}
          </button>
        ))}
      </div>
    </div>
  );
};

const Body = ({
  data,
  loading,
  type,
}: {
  data: any[];
  loading: boolean;
  type: string;
}) => {
  if (loading) {
    return (
      <div className="w-full h-full flex justify-center items-center py-10">
        <FaSpinner className="animate-spin text-blue-500 dark:text-white" />
      </div>
    );
  }
  return (
    <div className="col-2 space-y-2 mt-2">
      {data.map((user, index) => (
        <div
          key={user.id || index}
          className="row-2 rounded-lg px-4 py-2 bg-BG-light dark:bg-zinc-800/90 dark:border dark:border-zinc-700/50 shadow-sm"
        >
          <div className="row-2 items-center">
            <Position index={index} />
            <img
              className="size-11 rounded-full object-cover"
              src={user.image_url || "/IVCartoon.png"}
              alt={user.username}
            />
          </div>
          <div className="flex flex-col justify-center ml-2">
            <span className="inter-xs-bold-black dark:text-zinc-100">
              {user.username || `${user.firstname}`}
            </span>
            <span className="inter-xs-bold-pry-600 text-[10px] dark:text-blue-400">
              {type === "monthly"
                ? user.monthly_accumulated_points
                : user.alltime_accumulated_points}{" "}
              pts
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

const Position = ({ index }: { index: number }) => {
  const commonClassses =
    "size-6 flex items-center justify-center rounded-full p-2 mr-3";
  if (index < 3) {
    const lbColor = ["#FFBF00", "#C0C0C0", "#CD7F32"];
    const bgColor = lbColor[index];
    return (
      <span
        className={`${commonClassses} satoshi-sm-bold-white text-[10px]`}
        style={{ backgroundColor: bgColor }}
      >
        {index + 1}
      </span>
    );
  } else {
    return (
      <span
        className={`${commonClassses} satoshi-sm-bold-toggleBG-dark text-[10px] dark:text-zinc-300 border border-border-light dark:border-zinc-600`}
      >
        {index + 1}
      </span>
    );
  }
};
